import { Button } from 'antd';
import styled from 'styled-components';

export const ReservationRegisterContainer = styled.div`
  display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
  padding: 20px;
  box-sizing: border-box;
`

export const StyledHeader = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: flex-start;
	height: 30px;
	margin-bottom: 15px;
	h1 {
		font-family: 'Suit extra bold', 'Inter bold';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 0px;
	}
	${({ theme }) =>
    theme.media.monitor(
      `
				margin-bottom: 30px;
    	`,
    )}
`

export const StyledBackBtn = styled.div`
	width: 73px;
	height: 30px;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 5px;
	border: solid 1px rgba(215, 214, 217, 1);
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: 'Suit regular';
	color: rgba(126, 126, 128, 1);
	font-size: 14px;
	font-weight: 400;
	line-height: 22px;
	cursor: pointer;
	
	&:hover {
    background-color: rgba(18, 6, 45, 1);
		color: rgba(255, 255, 255, 1);
  }
	${({ theme }) =>
		theme.media.monitor(
			`
					width: 95px;
					height: 35px;
					font-size: 18px;
			`,
		)}
`;

export const StyledContent = styled.section`
	width: 100%;
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	overflow: auto;
	height: 100%;
	${({ theme }) =>
			theme.media.mobile(
				`
					height: 600px;
					margin-bottom: 40px;
				`,
			)}
`

export const Content = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	row-gap: 50px;
	border-radius: 10px;
	background-color: #ffffff;
	padding: 35px;
	${({ theme }) =>
    theme.media.mobile(
      `
				padding: 12px;
				row-gap: 20px;
				border-radius: 4px;
    	`,
    )}
	h2 {
		color: rgba(38, 38, 38, 1);
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		font-family: 'Suit extra bold';
		display: flex;
		justify-content: flex-start;
		align-items: center;
		${({ theme }) =>
    theme.media.mobile(
      `
				font-size: 16px;
    	`,
    )}
		${({ theme }) =>
    theme.media.monitor(
      `
				font-size: 24px;
    	`,
    )}
	}
`


export const StyledFormContent = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 22px;
`;

export const StyledHeaderForm = styled.div`
	display: flex;
	width: 100%;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-end;
	column-gap: 10px;
	p {
		color: rgba(126, 126, 128, 1);
		font-size: 12px;
		font-weight: 400;
		font-family: 'Suit regular';
		height: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		text-align: end;
		
		${({ theme }) =>
    theme.media.mobile(
      `
				font-size: 10px;
    	`,
    )}
	}
`;


export const StyledSubmitBtn = styled(Button)`
  width: 100%;
  height: 70px;
  background-color: rgba(90, 30, 219, 1);
  color: white;
  border-radius: 10px;
  font-family: 'Suit bold';
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
	margin-bottom: 20px;
  &:hover {
    background-color: rgba(90, 30, 219, 1) !important;
		color: white !important;	
  }
	@media screen and (min-width: 300px) and (max-width: 1000px) {
		height: 50px;
		font-size: 15px;
		margin-bottom: 10px;
	}
	${({ theme }) =>
      theme.media.monitor(
        `
          height: 82px;
        `,
      )}
`;

export const StyledForm = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	align-items: center;
	column-gap: 20px;
  ${({ theme }) =>
    theme.media.mobile(
      `
				column-gap: 5px;
    	`,
    )}
`

export const FormList = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	width: 100%;
  ${({ theme }) =>
    theme.media.mobile(
      `
				row-gap: 10px;
    	`,
    )}
	p {
		color: rgba(253, 51, 38, 1);
		font-size: 12px;
		font-weight: 400;
		font-family: 'Suit regular';
    ${({ theme }) =>
    theme.media.mobile(
      `
				font-size: 18px;
    	`,
    )}
    ${({ theme }) =>
    theme.media.monitor(
      `
				font-size: 18px;
    	`,
    )}
	}
	label {
		color: rgba(38, 38, 38, 1);
		font-size: 18px;
		font-weight: 700;
		line-height: 22px;
		font-family: 'Suit bold';
		margin-right: 10px;
    ${({ theme }) =>
    theme.media.mobile(
      `
				font-size: 15px;
    	`,
    )}
    ${({ theme }) =>
    theme.media.monitor(
      `
				font-size: 20px;
    	`,
    )}
	}
`

export const StyledInputContainer = styled.div<{icon: string}>`
	  position: relative;
		display: inline-block;
		input {
			padding-right: 30px; 
		}
		&::after {
			content: '${(props) => props.icon}';
			position: absolute;
			right: 10px;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none; 
			font-size: 16px;
			color: rgba(151, 151, 153, 1);
      ${({ theme }) =>
      theme.media.monitor(
        `
          font-size: 19px;
        `,
      )}
      }
`;

export const StyledInput = styled.input`
	width: 100%;
	height: 46px;
	border: solid 1px rgba(202, 201, 204, 1);
	background-color: #FFFFFF;
	border-radius: 4px;
	font-family: 'Suit regular', 'Inter regular';
	font-weight: 400;
	font-size: 16px;
	color: rgba(38, 38, 38, 1);
	text-indent: 15px;
  ${({ theme }) =>
    theme.media.mobile(
      `
				font-size: 13px;
        height: 40px;
        text-indent: 5px;
    	`,
    )}
  ${({ theme }) =>
    theme.media.monitor(
      `
				height: 55px;
        font-size: 19px;
    	`,
    )}
	
	&::placeholder {
		color: rgba(151, 151, 153, 1);
		opacity: 1;
	}
	
	&:disabled {
		background-color: rgba(250, 249, 252, 1);
		color: rgba(126, 126, 128, 1);
	}
`